export const APPLICATION_NAME = 'react-app';
export const BASE_URL: string = import.meta.env.VITE_APP_BASE_URL || 'BASEURL';
export const API_GATEWAY: string = import.meta.env.VITE_API_GATEWAY_URL || 'BASEURL';
export const TRIP_MANAGEMENT_BASE_URL: string = `${BASE_URL}/trip-management`;
export const TRAVELER_MANAGEMENT_SERVICE_BASE_URL: string = `${BASE_URL}/traveler-management`;
export const LLM_BASE_URL: string = `${BASE_URL}/llm-service`;
export const AGENCY_MANAGEMENT_BASE_URL: string = `${BASE_URL}/agency-management`;
export const PERSON_MANAGEMENT_BASE_URL: string = `${BASE_URL}/person-management`;
export const DOCUMENT_MANAGEMENT_BASE_URL: string = `${BASE_URL}/document-management`;
export const CUSTOMER_MANAGEMENT_BASE_URL: string = `${BASE_URL}/customer-management`;
export const TRIP_OPERATIONS_MANAGEMENT_BASE_URL: string = `${BASE_URL}/trip-operations-management`;
export const MOBILITY_MANAGEMENT_BASE_URL: string = `${BASE_URL}/mobility-management`;
export const TRIP_FLIGHT_MANAGEMENT_BASE_URL: string = `${BASE_URL}/flight-management`;
export const LOCATION_MANAGEMENT_BASE_URL: string = `${BASE_URL}/location-service`;
export const TRIP_TRANSPORT_MANAGEMENT_BASE_URL: string = `${BASE_URL}/transport-management`;
export const TRIP_ACCOMMODATION_MANAGEMENT_BASE_URL: string = `${BASE_URL}/accommodation-management`;
export const INVOICE_MANAGEMENT_BASE_URL: string = `${BASE_URL}/invoice-management`;
export const DASHBOARD_MANAGEMENT_BASE_URL: string = `${BASE_URL}/dashboard-management`;
export const NOTIFICATION_MANAGEMENT_BASE_URL: string = `${BASE_URL}/notification`;
export const INTELLIGENT_SEARCH_BASE_URL: string = `${BASE_URL}/intelligent-search-service`;
export const TOKEN_KEY: string = import.meta.env.VITE_APP_TOKEN_KEY || 'TOKEN_KEY_HERE';
export const APP_EK: string = import.meta.env.VITE_APP_ENCRYPTION_KEY || 'ENCRYPTION_KEY_HERE';
export const ENABLE_REDUX_LOGGER: boolean = import.meta.env.VITE_APP_ENABLE_REDUX_LOGGER === 'true';
export const ENABLE_MSW: boolean = import.meta.env.VITE_APP_ENABLE_MSW === 'true';
export const FIREBASE_API_KEY: string = import.meta.env.VITE_APP_FIREBASE_API_KEY || 'FIREBASE_API_KEY_HERE';
export const FIREBASE_AUTH_DOMAIN: string =
  import.meta.env.VITE_APP_FIREBASE_AUTH_DOMAIN || 'FIREBASE_AUTH_DOMAIN_HERE';
export const VITE_AUTO_LOGOUT_MINUTES: number = import.meta.env.VITE_APP_AUTO_LOGOUT_MINUTES || 15;
export const MAX_FILE_SIZE_MB: number = Number(import.meta.env.VITE_APP_MAX_FILE_SIZE_MB) || 5;

export const httpVerbs = {
  POST: 'POST',
  PATCH: 'PATCH',
  GET: 'GET',
  PUT: 'PUT',
  DELETE: 'DELETE',
};
